import React from 'react'
import VideoOverlay from './VideoOverlay'
import DocumentarySection from './DocumentarySection'
import ShortsSection from './ShortsSection'
import KidStoriesSection from './KidStoriesSection'
import Footer from '../../common/UI/Footer'

export default function VideoMainPage() {
  return (
    <>
      <VideoOverlay/>
      <DocumentarySection/>
      <ShortsSection/>
      <KidStoriesSection/>
      <Footer/>
    </>
  )
}
